<!-- DIALOG SHOWN WHEN CHANGING LOCATION OF MULTPLE ARTWORKS 
IT CAN BE OPENED FROM ARTWORKS TABLE OR TOOLBAR -->

<template>
  <div>
    <v-dialog v-model="showDialog" max-width="900px" class="rounded-card" persistent>
      <v-card class="pt-0 rounded-card">

        <v-card-title class="title red white--text px-4 mb-4 pt-3 pb-2">Add Location History Entry and Change Location
          of
          {{
            selected.length
          }} Artworks
          <v-spacer></v-spacer>
          <v-btn outline small color="white" @click="closeChangeLocationDialog">Cancel</v-btn>
        </v-card-title>

        <!-- FORM FOR LOCATION CHANGE -->
        <v-layout row wrap mx-4>
          <v-flex xs12>
            <v-autocomplete :items="locations" v-model="artwork_location_log.artwork_location_id" item-text="name"
              item-value="id" label="New Location" clearable></v-autocomplete>
          </v-flex>

          <!-- Reason -->
          <v-flex class="sm12 md6 pr-3">
            <v-text-field v-model="artwork_location_log.reason" name="reason" label="Reason" clearable></v-text-field>
          </v-flex>

          <!-- Shipper -->
          <v-flex class="sm12 md6">
            <v-text-field v-model="artwork_location_log.shipper" name="shipper" label="Shipper" clearable></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field v-model="artwork_location_log.note" label="Note" class="pr-0" clearable></v-text-field>
          </v-flex>

        <!-- IN OUT -->
        <v-flex class="xs6 mb-0 pl-3 mt-1 pt-3">
          <!-- <v-btn-toggle v-model="toggle" @change="saveField(toggle)">
                <v-btn small flat v-for="s in f_field.selection" :key="s.id ? s.value : s" class="px-2" :value="s.value">
                                                                          <span> {{s.name}} </span>
                                                                          </v-btn>
                                                                      </v-btn-toggle>             -->
            <v-btn-toggle mandatory v-model="artwork_location_log.storage" active-class="activeToggle">
              <v-btn value="in" small flat class="px-3">
                <v-icon small>call_received</v-icon> IN
              </v-btn>
              <v-btn value="out" small flat class="px-3">
                OUT <v-icon small>call_made</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <!-- DATE -->
          <v-flex xs6>
            <!-- :return-value.sync="artwork_location_log.change_date" -->
            <v-menu v-model="menu2a" ref="menu2a" :close-on-content-click="true" :nudge-right="40" lazy landscape
              transition="scale-transition" offset-y full-width min-width="290px">
              <v-text-field v-model="artwork_location_log.change_date" slot="activator" label="Change Date"
                prepend-inner-icon="event" readonly></v-text-field>
              <v-date-picker persistent color="black" v-model="artwork_location_log.change_date"></v-date-picker>
              <!-- @input="save(artwork_location_log.change_date)" -->
              <!-- @input="$refs.menu2.save(artwork_location_log.change_date)" -->
            </v-menu>
          </v-flex>
        </v-layout>

        <div v-if="artwork_location_log.artwork_location_id && artwork_location_log.change_date">

          <v-card-title class="subheading font-weight-medium pl-4 py-2 my-1 black white--text">
            Select Artwork Packings to include in this action
        </v-card-title>

          <!-- LISTING OF ARTWORKS AND PACKINGS TO CHANGE -->
          <v-container grid-list-xs text-xs-start>
            <v-layout row wrap mx-0 pl-0 pt-0>
              <v-flex xs12 pt-0>
                <v-checkbox class="ml-2 mt-0 pt-0 pb-2" label="Include all Packings of All Artworks"
                  @change="moveAllPackings($event)" v-model="moveAllPackingsSwitch" value="1" hide-details color="black"
                  :indeterminate="
                    this.selectedPackings.length != 0 &&
                    this.selectedPackings.length != this.packings.length
                  "></v-checkbox>
                  <div style="font-weight: 500;" class="ml-2 mt-2 title" >
                    {{ this.selectedPackings.length }} of {{ this.packings.length }} Packings selected for update.<br >
                    {{ this.selected.length }} Artworks selected for update.
                  </div>

                <!-- LIST SELECTED ARTWORKS AND PACKINGS  -->
                <v-card v-for="a in this.selected" :key="a.id" xs12 my-0 pb-0 pt-0 pl-2 class="rounded-card-small">

                  <!-- GENERAL ARTWORK INFO -->
                  <v-card-title xs12 class="title mt-3 pt-3 grey lighten-3 pb-3 justify-space-between ">
                    {{ a.title }}, {{ a.accession_number }}
                    <v-btn color="white" icon @click="removeArtworkFromSelection(a)">X</v-btn>
                  </v-card-title>
                  <v-card-title xs12 class="title my-0 pt-0 pb-3 grey lighten-3">
                    <small> {{ a.name }}</small>
                  </v-card-title>

                  <v-card-title xs12 class="subtitle mt-0 pb-2 pt-2 grey lighten-5">
                    Current Artwork Location
                    <v-icon class="mx-2" small color="black">adjust</v-icon>
                    {{ get_location_name(a.artwork_location_id) }}
                  </v-card-title>
                  <!-- {{ a.id }} -->
                  <!-- {{ lastLocationLogArtwork(a.id) }} -->
                  <!-- {{ lastArtworkChangeDate(a.id) }} -->
                  <!-- this.lastArtworkChangeDate(a.id) -->

                  <!-- if date is later than latest change and location_id is different from current, show message that artwork will be changed -->
                  <v-flex green--text mx-3>
                    Location History entry for this Artwork will be created.
                  </v-flex>
                  <v-flex v-if="(artwork_location_log.change_date > (lastArtworkChangeDate(a.id)))
                    && artwork_location_log.artwork_location_id != a.artwork_location_id" green--text
                    font-weight-medium pb-2 mx-3>
                    Current Artwork Location will be also changed:<br />
                    <!-- artwork_location_log.change_date: {{ artwork_location_log.change_date }}<br /> -->
                    <!-- lastLocationLogArtwork.change_date: {{ lastLocationLogArtwork(a.id).change_date }}<br /> -->
                    {{ get_location_name(a.artwork_location_id) }} =>
                    <b>{{ get_location_name(artwork_location_log.artwork_location_id) }}</b>
                  </v-flex>

                  <!-- if conditions are not met, show for each condition a message -->
                  <v-flex v-else>
                    <div v-if="artwork_location_log.artwork_location_id == a.artwork_location_id"
                      class="red--text mx-3 pb-2">
                      This artwork's current location will <b>NOT</b> be changed, because artwork's location is the same
                      as selected location.
                    </div>
                    <div v-if="artwork_location_log.change_date <= lastArtworkChangeDate(a.id)"
                    class="mx-3 pb-2 red--text">
                    This artwork's current location will <b>NOT</b> be changed, because a location
                    history entry with newer Change Date exists.
                  </div>
                </v-flex>

                  <!-- IF ARTWORK HAS PACKINGS LIST THEM -->
                  <v-flex v-if="getArtworkPackings(a.id) && getArtworkPackings(a.id).length > 0" mx-0 mb-2 pb-2>

                    <!-- CHANGE ALL PACKINGS CHECKBOX -->
                    <v-card-title xs12 class="pt-0 mt-0 pb-2">
                      <v-checkbox @change="moveOrRemoveAllPackingsforArtwork($event, a.id)" color="black" hide-details
                        class="py-0 small mb-1 mt-2" label="Include all Artwork packings" v-model="selectedArtworks"
                        :indeterminate="
                          selectedPackings.length != 0 &&
                          hasSomePackingsSelected(a.id)
                        " :value="a.id"></v-checkbox>
                      <!-- </v-flex> -->
                    </v-card-title>

                    <!-- LIST ALL PACKINGS -->
                    <v-layout v-for="ap in packings.filter((aap) => aap.artwork_id == a.id)" :key="ap.id" xs12
                      align-center row wrap fill-height px-3 pb-1>
                      <div style="width:100%">
                        <v-checkbox color="black" class="my-0 py-0 shorten-text" hide-details
                          :label="`${ap.colli}, ${ap.packing}, ${ap.contents}`"
                          v-model="selectedPackings"
                          :value="ap.id"></v-checkbox>
                        <v-flex green--text ml-4 v-if="selectedPackings.includes(ap.id)">
                          Location History entry for this Packing will be created.
                        </v-flex>

                      </div>
                      <div class="ml-4 mt-1 mb-1">
                        <v-icon class="mx-2" small color="black">adjust</v-icon> {{
                          get_location_name(ap.artwork_location_id)
                        }}
                        <span v-if="!ap.artwork_location_id">
                          No Packing Location entered.
                        </span>
                      </div>

                      <!-- {{ ap.id }} -->
                      <!-- {{ lastLocationLogArtworkPacking(ap.id) }} -->

                      <v-flex v-if="selectedPackings.includes(ap.id)">

                        <!-- IF CHANGE DATE IS NEWER THAN LAST PACKING'S HISTORY ENTRY, IT WILL BE CHANGED -->
                        <div class="green--text"
                          v-if="(artwork_location_log.change_date >
                            lastLocationLogArtworkPacking(ap.id).change_date) && artwork_location_log.artwork_location_id != lastLocationLogArtworkPacking(ap.id).artwork_location_id">
                          <span class="ml-2 mr-1"> => </span>
                          <b>{{ get_location_name(artwork_location_log.artwork_location_id) }}</b>
                        </div>

                      <!-- ELSE - IT WILL NOT BE CHANGED -->
                      <!-- <v-flex xs12 v-else class="red--text ml-4 pl-2 my-1">
                                                                            This packing's current location will <b>NOT</b> be changed, because a location
                                                                            history entry with newer Change Date exists.
                                                                          </v-flex> -->

                        <!-- if conditions are not met, show for each condition a message -->
                        <v-flex v-else>
                          <div
                            v-if="artwork_location_log.artwork_location_id == lastLocationLogArtworkPacking(ap.id).artwork_location_id"
                            class="red--text mx-3 pb-2">
                            This packing's current location will <b>NOT</b> be changed, because it's location is the same
                            as selected new location.
                          </div>
                          <div v-if="artwork_location_log.change_date <= lastArtworkPackingChangeDate(ap.id)"
                            class="mx-3 pb-2 red--text">
                            This packing's current location will <b>NOT</b> be changed, because a location
                            history entry with newer Change Date exists.
                          </div>
                        </v-flex>
                      </v-flex>
                    </v-layout>

                  </v-flex>

                </v-card>

              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-4 justify-end mr-4 pr-0">
            <v-btn outline small @click="closeChangeLocationDialog">Cancel</v-btn>

            <v-btn @click="changeLocation" small :dark="
              !(
                artwork_location_log.artwork_location_id == null ||
                artwork_location_log.artwork_location_id == ''
              ) &&
              !(
                artwork_location_log.change_date == null ||
                artwork_location_log.change_date == ''
              )
            " :disabled="
  artwork_location_log.artwork_location_id == null ||
  artwork_location_log.artwork_location_id == '' ||
  artwork_location_log.change_date == null ||
  artwork_location_log.change_date == ''
">Change</v-btn>
          </v-card-actions>
        </div>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { serverBus } from '../../../main'

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

export default {
  props: ['showDialog', 'selected'],
  watch: {
    selected: function () {
      this.getPackings()
      this.getLocationLogs()
    },
  },
  created() {
    this.getPackings()
    this.getLocationLogs()
  },
  data() {
    return {
      selectedPackings: [],
      selectedArtworks: [],
      moveAllPackingsSwitch: null,
      packings: [],
      menu2a: false,
      artwork_location_log: {
        storage: 'in',
        note: '',
        change_date: '',
        copy: 'artwork',
        storage_in: '',
        storage_out: '',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: '',
        artwork_id: '',
      },
    }
  },
  methods: {
    removeArtworkFromSelection(artwork) {
        var index = this.selected.indexOf(artwork)
        if (index > -1) {
          this.selected.splice(index, 1)
      }
    },
    lastArtworkChangeDate(artwork_id) {
      var last = this.lastLocationLogArtwork(artwork_id).change_date
      if (last) {
        return last
      } else {
        return '1900-01-01'
      }
    },
    lastArtworkPackingChangeDate(packing_id) {
      var last = this.lastLocationLogArtworkPacking(packing_id).change_date
      if (last) {
        return last
      } else {
        return '1900-01-01'
      }
    },
    lastLocationLogArtworkPacking(id) {
      return this.getLastLog(this.logs, 'packings', id)
    },
    lastLocationLogArtwork(id) {
      return this.getLastLog(this.logs, 'artwork', id)
    },
    getLastLog(logs, copy, id) {
      if (copy == 'packings') {
        if (logs && logs.length > 0) {
          var out = logs
            .filter((ll) => ll.artwork_packing_id === id)
            .sort(function (a, b) {
              if (a.change_date > b.change_date) {
                return -1
              }
              if (a.change_date < b.change_date) {
                return 1
              }
              return 0
            })[0]
          if (out) {
            return out
          } else {
            return ''
          }
        } else {
          return ''
        }
      } else {
        if (logs && logs.length > 0) {
          var out = logs
            .filter((ll) => ll.copy === copy && ll.artwork_id == id)
            .sort(function (a, b) {
              if (a.change_date > b.change_date) {
                return -1
              }
              if (a.change_date < b.change_date) {
                return 1
              }
              return 0
            })[0]
          if (out) {
            return out
          } else {
            return ''
          }
        } else {
          return ''
        }
      }
    },
    
    /**
     * Toggles the selection of all packings for a specific artwork.
     * Adds all packings of the artwork to selectedPackings if checked, otherwise removes them.
     * @param {Boolean} isChecked - Whether the checkbox is checked.
     * @param {Number} artworkId - The ID of the artwork.
     */
    // moveOrRemoveAllPackingsforArtwork(checkboxValue, artworkId) {
    //   const artworkPackingsIds = this.packings
    //     .filter(packing => packing.artwork_id === artworkId)
    //     .map(packing => packing.id);
    //     console.log(artworkPackingsIds)
    //   if (checkboxValue === artworkId) {
    //   console.log(this.selectedPackings)
    //       // Add all packings for this artwork, avoiding duplicates
    //       this.selectedPackings = [...new Set([...this.selectedPackings, ...artworkPackingsIds])];

    //   } else {
    //   console.log(this.selectedPackings)
    //       // Remove all packings for this artwork
    //       this.selectedPackings = this.selectedPackings.filter(id => !artworkPackingsIds.includes(id));
    //   }
    // },

    /**
     * Toggles the selection of all packings for a specific artwork based on the checkbox state.
     * Adds all packings of the artwork to selectedPackings if checked, otherwise removes them.
     * @param {Array} checkboxValue - The value from the checkbox, either an empty array or an array with packing IDs.
     * @param {Number} artworkId - The ID of the artwork.
     */
     moveOrRemoveAllPackingsforArtwork(checkboxValue, artworkId) {
        const artworkPackingsIds = this.packings
            .filter(packing => packing.artwork_id === artworkId)
            .map(packing => packing.id);

        if (checkboxValue.includes(artworkId)) {
            // Add all packings for this artwork, avoiding duplicates
            this.selectedPackings = Array.from(new Set([...this.selectedPackings, ...artworkPackingsIds]));
        } else {
            // Remove all packings for this artwork
            this.selectedPackings = this.selectedPackings.filter(id => !artworkPackingsIds.includes(id));
        }
    },

    // NOT USED
    moveAllPackingsforArtwork(e, id) {
      // console.log(id)
      // console.log(this.selectedPackings)
      this.selectedPackings = this.selectedPackings.filter(
        (p) => this.packings.find((pp) => pp.id == p).artwork_id != id
      )
      console.log(this.selectedPackings)
      if (e.includes(id)) {
        // console.log('e')
        // console.log(e[0])
        // console.log('e')
        // console.log(id)
        this.selectedPackings = this.selectedPackings.concat(
          this.packings.filter((p) => p.artwork_id == id).map((ppp) => ppp.id)
        )
      }
      if (!this.selectedPackings) {
        this.selectedPackings = []
      }
      // console.log(this.selectedPackings)
    },
    /**
     * Moves all packings.
     *
     * @param {Event} e - The event object.
     * @return {void} This function does not return a value.
     */
    moveAllPackings(e) {
      if (e) {
        this.selectedPackings = this.packings.map((p) => p.id)
      } else {
        this.selectedPackings = []
      }
    },
    getPackings() {
      var ids = this.selected.map((a) => a.id)
      console.log(this.selected)
      console.log(ids)
      axios
        .get(`${this.$globals.apiserver}/artwork_packings.json`, {
          params: {
            // user_id: localStorage.getItem('user-token'),
            artwork_ids: ids,
          },
        })
        .then((r) => (this.packings = r.data))
      console.log('Packings loaded')
    },
    getLocationLogs() {
      var ids = this.selected.map((a) => a.id)
      console.log(this.selected)
      console.log(ids)
      axios
        .get(`${this.$globals.apiserver}/artwork_location_logs.json`, {
          params: {
            // user_id: localStorage.getItem('user-token'),
            artwork_ids: ids,
          },
        })
        .then((r) => (this.logs = r.data))
      console.log('Logs loaded')
    },
    getArtworkPackings(id) {
      return this.packings.filter((p) => p.artwork_id == id)
      // console.log('Artwork Packings filtered')
    },
    closeChangeLocationDialog() {
      this.artwork_location_log = {
        storage: 'in',
        storage_in: '',
        storage_out: '',
        note: '',
        change_date: '',
        copy: 'artwork',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: '',
        artwork_id: '',
      }
      this.$emit('hideDialog')
    },

    /**
     * Batch change of artwork and packings location and creating a new log entry.
     */
    async changeLocation() {
        this.setupLogBasics();
        serverBus.$emit('showSnackbar', `Adding Location History Entry/Changing locations - ${this.selected} artworks …`, 'green');

        await this.handleArtworksUpdate();
        await this.handlePackingsUpdate();

        this.resetStateAfterSave();
        this.$emit('hideDialog');
    },
    /**
     * Sets up the basic configuration for the artwork location log.
     */
    setupLogBasics() {
        this.artwork_location_log.created_by = this.c_user.id;
        this.artwork_location_log.last_update_by = this.c_user.id;
        this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id;

        if (this.artwork_location_log.storage === 'in') {
            this.artwork_location_log.storage_in = this.artwork_location_log.change_date;
        } else {
            this.artwork_location_log.storage_out = this.artwork_location_log.change_date;
        }

        // Handling a case where the country_id might be undefined
        // this.artwork_location_log.country_id = this.artwork_location_log.country_id || '';
    },
    /**
     * Processes the update for selected artworks.
     */
    async handleArtworksUpdate() {
        for (const artwork of this.selected) {
            await this.updateArtwork(artwork);
        }
    },
    /**
     * Updates an individual artwork's location and creates a log entry.
     * @param {Object} artwork - The artwork object to be updated.
     */
    async updateArtwork(artwork) {
        try {
            // Check if the artwork location needs to be updated
            const lastLog = this.lastLocationLogArtwork(artwork.id);
            if (this.artwork_location_log.artwork_location_id !== artwork.artwork_location_id &&
                this.artwork_location_log.change_date > lastLog.change_date) {
                
                // Update the artwork's location
                const updateResponse = await axios.put(`${this.$globals.apiserver}/artworks/${artwork.id}.json`, {
                    artwork: {
                        artwork_location_id: this.artwork_location_log.artwork_location_id,
                    },
                });

                // Create a log entry for the artwork update
                const logResponse = await axios.post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
                    artwork_location_log: {
                        ...this.artwork_location_log,
                        artwork_id: artwork.id,
                        copy: 'artwork',
                    },
                });

                // Update local state with new log
                this.$store.commit('ADD_LOG', logResponse.data);
                serverBus.$emit('showSnackbar', `Location of ${artwork.title} saved.`, 'green');
            }
        } catch (error) {
            console.error(`Failed to update location for artwork ${artwork.title}:`, error);
            serverBus.$emit('showSnackbar', 'Error occurred while updating location.', 'red');
            // You might want to handle different types of errors differently
            // this.errors = error.response.data; // Uncomment this if you need to handle specific error data
        }
    },
    /**
     * Processes the update for selected packings.
     */
    async handlePackingsUpdate() {
        for (const packingId of this.selectedPackings) {
            await this.updatePacking(packingId);
        }
        this.selectedPackings = []; // Reset selected packings after processing
    },
    /**
     * Updates the location of an individual packing and creates a log entry.
     * @param {Number} packingId - The ID of the packing to be updated.
     */
    async updatePacking(packingId) {
        try {
            // Find the selected packing
            const packing = this.packings.find(p => p.id === packingId);

            if (!packing) {
                console.warn(`Packing with ID ${packingId} not found.`);
                return;
            }

            // Check if the packing location needs to be updated
            const lastLog = this.lastLocationLogArtworkPacking(packing.id);
            if (this.artwork_location_log.artwork_location_id !== packing.artwork_location_id &&
                this.artwork_location_log.change_date > lastLog.change_date) {

                // Update the packing's location
                const updateResponse = await axios.put(`${this.$globals.apiserver}/artwork_packings/${packing.id}.json`, {
                    artwork_packing: {
                        artwork_location_id: this.artwork_location_log.artwork_location_id,
                    },
                });

                // Create a new log entry for the packing
                const log = {
                    ...this.artwork_location_log,
                    artwork_id: packing.artwork_id,
                    artwork_packing_id: packing.id,
                    copy: 'packings'
                };
                const logResponse = await axios.post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
                    artwork_location_log: log,
                });

                // Update local state with new log
                this.$store.commit('ADD_LOG', logResponse.data);
                serverBus.$emit('showSnackbar', `Location of packing ID ${packing.id} saved.`, 'green');
            }
        } catch (error) {
            console.error(`Failed to update location for packing ID ${packingId}:`, error);
            serverBus.$emit('showSnackbar', 'Error occurred while updating packing location.', 'red');
            // You might want to handle different types of errors differently
            // this.errors = error.response.data; // Uncomment this if you need to handle specific error data
        } finally {
            // Additional cleanup or state updates can go here if needed
        }
    },
    /**
     * Resets the component state after saving updates.
     * This includes clearing the artwork location log, resetting selected packings and artworks, and other relevant states.
     */
    resetStateAfterSave() {
        // Reset artwork location log to its default state
        this.artwork_location_log = this.getDefaultLogObject();

        // Clear selected artworks and packings
        this.selected = [];
        this.selectedPackings = [];
        this.selectedArtworks = [];

        // Reset any additional states as required
        // For example, if you have flags like 'changeArtworkLocation', reset them here
        this.changeArtworkLocation = false;
        this.moveAllPackingsSwitch = null;

        // Reload artworks and packings if needed
        this.$store.dispatch('loadArtworks');
        // Add similar dispatch for packings if there's a specific state or list for them

        // Emit an event or perform any other cleanup actions
        // this.$emit('updateComplete'); // Uncomment or modify based on your event handling needs
    },

    getDefaultLogObject() {
        return {
            created_by: this.c_user.id,
            storage: 'in',
            note: '',
            change_date: '',
            copy: 'artwork',
            shipper: '',
            reason: '',
            artwork_location_id: '',
            artwork_packing_id: '',
        };
    },
    // END OF GENERATED CODE

    // BATCH CHANGE OF ARTWORK AND PACKINGS LOCATION AND CREATING A NEW LOG ENTRY
    changeLocation_old() {
      this.artwork_location_log.created_by = this.c_user.id
      this.artwork_location_log.last_update_by = this.c_user.id
      this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id
      if (this.artwork_location_log.storage === 'in') {
        this.artwork_location_log.storage_in = this.artwork_location_log.change_date
      } else {
        this.artwork_location_log.storage_out = this.artwork_location_log.change_date
      }

      serverBus.$emit(
        'showSnackbar',
        `Adding Location History Entry/Changing locations - ${this.selected} artworks …`,
        'green'
      )

      /// kvoli mazaniu aktualnej hodnoty - autocomplete totiz vracia undefined ak je prazdny a potom neposle field vobec a preto nevymaze v rails hodnotu
      // this.artwork_location_log.country_id = this.artwork_location_log
      //   .country_id
      //   ? this.artwork_location_log.country_id
      //   : ''

      // LOOPUJEM CEZ ARTWORKY
      console.log(this.selected)
      this.selected.forEach((a) => {

        // NASETUJEM BASICS FOR NEW ARTWORK LOG
        this.artwork_location_log.artwork_id = a.id
        this.artwork_location_log.copy = 'artwork'

        // CREATE LOG FOR ALL SELECTED ARTWORKS
        console.log('Starting location update --------- ' + a.title)

        axios
          .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
            artwork_location_log: this.artwork_location_log,
          })
          .then((response) => {
            console.log('Location update SUCCESSFUL --------- ' + a.title)
            this.errors = {}
            serverBus.$emit(
              'showSnackbar',
              `Location of ${a.title} saved.`,
              'green'
            )
            this.$store.commit('ADD_LOG', response.data)
            // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
            // this.showUpload = !this.showUpload
          })
          .catch((error) => {
            console.log('Location update FAILED --------- ' + a.title)
            console.log(error)
            serverBus.$emit(
              'showSnackbar',
              'Error occured while updating location.',
              'red'
            )
            // this.errors = error.response.data;
          })

        // ARTWORK SAMOTNY MENIM LEN AK NEEXISTUJE LOG S ROVNAKYM ALEBO NOVSIM CHANGE_DATE
        // AND NEW LOCATION IS DIFFERENT FROM CURRENT ONE
        var lastLog = this.lastLocationLogArtwork(a.id)
        if (this.artwork_location_log.artwork_location_id != a.artwork_location_id
          && this.artwork_location_log.change_date > lastLog.change_date) {

          // console.log(this.artwork_location_log.change_date)
          // console.log(this.lastLocationLogArtwork.change_date)
          axios
            .put(
              `${this.$globals.apiserver}/artworks/${a.id}.json`,
              {
                artwork: {
                  artwork_location_id:
                    this.artwork_location_log.artwork_location_id,
                },
              }
            )
            .then((response) => {
              console.log('changeArtworkLocation response change artwork')

              this.errors = {}
              // this.artwork.artwork_location_logs.push(response.data)

              // ON SAVE SUCCESS SET CURRENT ARTWORK'S LOCATION TO NEW LOCATION
              // if (this.artwork_location_log.copy === 'artwork') {
              //   this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
              // } else if (this.artwork_location_log.copy === 'master_physical') {
              //   this.artwork.master_physical_location_id = this.artwork_location_log.artwork_location_id
              // } else if (this.artwork_location_log.copy === 'archive_master') {
              //   this.artwork.archive_master_location_id = this.artwork_location_log.artwork_location_id
              // } else if (this.artwork_location_log.copy === 'access_copy') {
              //   this.artwork.access_copy_location_id = this.artwork_location_log.artwork_location_id
              // }
              // this.$store.commit('ADD_LOG', response.data)
              // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
              this.changeArtworkLocation = false
            })

        }
      })

      // LOOPUJEM CEZ SELECTED PACKINGS
      // FOR EACH SELECTED PACKING CREATE A HISTORY LOG AND CHANGE IT'S LOCATION
      // IF NEW CHANGE_DATE > AKO LAST LOG CHANGE DATE AND LOCATION IS NEW
      if (this.selectedPackings.length > 0) {
        var log = Object.assign({}, this.artwork_location_log)

        log.copy = 'packings'

        // LOOP THROUGH SELECTED PACKING IDs
        this.selectedPackings.forEach((p) => {

          // FIND SELECTED PACKING
          var pack = this.packings.find((ap) => ap.id == p)
          console.log(pack)

          // CREATE A NEW LOCATION HISTORY ENTRY FOR PACKING
          // this.artwork_location_log.artwork_packing_id = a.id
          log.artwork_id = pack.artwork_id
          log.artwork_packing_id = p
          axios
            .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
              artwork_location_log: log,
            })
            .then((response) => {
              this.errors = {}
              var log = Object.assign({}, this.artwork_location_log)

              // this.artwork.artwork_location_logs.push(response.data)
              this.$store.commit('ADD_LOG', response.data)
              // this.active_artwork_location_logs =
              //   this.$store.state.artwork_location_logs
              // this.showUpload = !this.showUpload
            })
            .catch((error) => {
              console.log(error)
            })


          // UPDATE PACKING IF:
          //   LOG CHANGE DATE IS NEWER THEN LAST PACKING LOG, 
          //   AND LOCATION_ID IS DIFFERENT FROM THE CURRENT ONE
          //   AND NEW LOCATION IS DIFFERENT FROM CURRENT ONE 
          //   -- UPDATE PACKING LOCATION
          if (log.artwork_location_id != pack.artwork_location_id
            && this.artwork_location_log.change_date > this.lastLocationLogArtworkPacking(pack.id).change_date) {

            axios
              .put(
                `${this.$globals.apiserver}/artwork_packings/${pack.id}.json`,
                {
                  artwork_packing: {
                    artwork_location_id:
                      this.artwork_location_log.artwork_location_id,
                  },
                }
              )
              .then((response) => {
                console.log('changeArtworkLocation response change artwork')
                this.errors = {}
                // this.artwork.artwork_location_logs.push(response.data)
                this.changeArtworkLocation = false
              })

          }
          this.selectedPackings = []
          this.moveAllPackingsSwitch = null

        })
      }

      this.$store.dispatch('loadArtworks')

      this.artwork_location_log = {
        storage: 'in',
        note: '',
        change_date: '',
        copy: 'artwork',
        storage_in: '',
        storage_out: '',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: '',
        artwork_id: '',
      }
      this.$emit('hideDialog')
    },
    /**
     * Check if there are any packings selected for a given artwork ID.
     * @param {number} id - The artwork ID to check against.
     * @returns {boolean} - True if there are selected packings, false otherwise.
     */
    hasSomePackingsSelected(id) {
      // Get the IDs of packings that have the given ID as artwork_id
      var apids = this.packings
        .filter((p) => p.artwork_id == id)
        .map((p) => p.id)

      // Filter the selectedPackings array to include only IDs that are in apids
      var selectedPackingsWithId = this.selectedPackings.filter((pp) => apids.includes(pp))

      // Return true if there are any selected packings with the given ID, false otherwise
      return selectedPackingsWithId.length > 0
    },
    // shouldUpdateArtworksLocation (artwork) {
    //   return !this.lastLocationLogArtwork || (this.artwork_location_log.change_date > this.lastLocationLogArtwork.change_date)
    // },

  },
  computed: {
    // selectedWithPackings() {
    //   return this.selected.filter((a) =>
    //     this.packings.find((p) => p.artwork_id == a.id)
    //   )
    // },
    locations() {
      return Object.assign([], this.$store.getters.enabled_locations).sort(
        dynamicSort('name')
      )
    },
  },
}
</script>

<style scoped>
.shorten-text {
  width: 98%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rounded-card {
  border-radius: 12px;
}

.theme--light.v-label {
  color: rgb(0 0 0 / 70%);
}

.rounded-card-small {
  border-radius: 8px;
}
</style>

                <!-- <v-flex xs6 pr-3>
                    <v-text-field
                    :disabled="artwork_location_log.storage_out != ''"
                    v-model="artwork_location_log.storage_in"
                    label="Storage IN"
                    mask="####-##-##"
                    placeholder="YYYY-MM-DD"
                    clearable
                    ></v-text-field>
                </v-flex>

                <v-flex xs6>
                    <v-text-field
                    :disabled="artwork_location_log.storage_in != ''"
                    v-model="artwork_location_log.storage_out"
                    label="Storage OUT"
                    mask="####-##-##"
                    placeholder="YYYY-MM-DD"
                    clearable
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 pr-3>
                    <v-text-field
                    v-model="artwork_location_log.change_date"
                    label="Change Date"
                    mask="####-##-##"
                    placeholder="YYYY-MM-DD"
                    clearable
                    ></v-text-field>
                </v-flex> -->

                <!-- <v-flex xs6 pl-5 pt-3>
                <v-btn-toggle mandatory v-model="artwork_location_log.copy">
                <v-btn
                    flat
                    small
                    key="group1"
                    class="px-3"
                    input-value="artwork"
                    value="artwork"
                    >Artwork</v-btn
                >
                <v-btn
                    flat
                    small
                    key="group2"
                    class="px-3"
                    input-value="copy"
                    value="copy"
                    >Copy</v-btn
                >
                </v-btn-toggle>
            </v-flex> -->



// WEBPACK FOOTER //
// src/components/layout/toolbar_items/LocationChangeDialog.vue